import { useTranslation } from 'react-i18next'

const GrantFitSummary = ({ summary }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  if (!summary) return

  return (
    <div className="grantfit-summary">
      {summary.timedOut && <p className="summary-error">{t.funder.grantFit.requestTimedOut}</p>}
      {summary.analysis && (
        <>
          <h3>{t.funder.grantFit.analysisTitle}</h3>
          <h4>{t.funder.grantFit.analysisSummary}</h4>
          <p className="summary-text">{summary.analysis.summary}</p>
          <h4>{t.funder.grantFit.analysisEvaluation}</h4>
          {summary.analysis.evaluation.map((item, index) => (
            <div key={index} className={`evaluation-box ${item.rating.toLowerCase()}`}>
              <h4 className="title">{item.title}</h4>
              <p>
                <span className="rating">{item.rating}</span>
                <span className="score">
                  <b>{t.funder.grantFit.analysisScore}: </b>
                  {item.score || t.funder.grantFit.analysisScoreNotAvailable}
                </span>
              </p>
              <p className="guidance">{item.guidance}</p>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default GrantFitSummary
